import { render, staticRenderFns } from "./type85.vue?vue&type=template&id=60d231d2&scoped=true"
import script from "./type85.vue?vue&type=script&lang=js"
export * from "./type85.vue?vue&type=script&lang=js"
import style0 from "./type85.vue?vue&type=style&index=0&id=60d231d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d231d2",
  null
  
)

export default component.exports